import React from 'react';
import { tocConfig } from './docStructure';

const TableOfContents = ({ activeSection }) => {
  const tocLinks = tocConfig[activeSection] || [];

  if (tocLinks.length === 0) {
    return null;
  }

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    const targetId = href.substring(1); // Remove the # symbol
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <aside className="docs-toc">
      <div className="toc-container">
        <h4>On this page</h4>
        <div className="toc-links">
          {tocLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              onClick={(e) => handleLinkClick(e, link.href)}
            >
              {link.title}
            </a>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default TableOfContents;